import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Box,
  Typography,
  Pagination,
} from "@mui/material";

import Preloader from "../../helper/Preloader";
import FooterOne from "../../components/FooterOne";
import BottomFooter from "../../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import HeaderOneCustomer from "../../componentsAmazon/HeaderOneCustomer";

import { useGetNotificationsPaginatedQuery } from "../../apis/NotificationApi";
import { getUserData } from "../../auth";

const NotificationsPageCustomer = () => {
  const [page, setPage] = useState(1);

  const userId = getUserData()?.uid || "";

  const {
    data,
    isLoading,
    isError,
  } = useGetNotificationsPaginatedQuery(
    { userId, page: page - 1, size: 10 },
    { skip: !userId }
  );

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const notifications = data?.content || [];
  const totalPages = data?.totalPages || 1;

  return (
    <>
      <Preloader />
      <ScrollToTop smooth color="#232F3F" />
      <HeaderOneCustomer />

      <Box sx={{ padding: 3, minHeight: "60vh" }}>
        <Typography variant="h4" gutterBottom>
          All Notifications
        </Typography>

        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", padding: 2 }}>
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Typography color="error">Failed to load notifications.</Typography>
        ) : notifications.length > 0 ? (
          <>
            <List>
              {notifications.map((notification) => (
                <ListItem
                  key={notification.id}
                  sx={{
                    backgroundColor: notification.read ? "inherit" : "#f5f5f5",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                    mb: 1,
                    borderRadius: 1,
                  }}
                >
                  <ListItemText
                    primary={notification.title}
                    secondary={
                      <>
                        <Typography variant="body2" color="textSecondary">
                          {notification.message}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ display: "block", marginTop: "4px" }}
                        >
                          {new Date(notification.createdAt).toLocaleString()}
                        </Typography>
                      </>
                    }
                    primaryTypographyProps={{
                      fontWeight: notification.read ? "normal" : "bold",
                    }}
                  />
                </ListItem>
              ))}
            </List>

            <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          </>
        ) : (
          <Typography>No notifications found.</Typography>
        )}
      </Box>

      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default NotificationsPageCustomer;
